import CookiePoliciesModalContainer from './CookiePoliciesModalContainer.component';
export default CookiePoliciesModalContainer;